"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolioController = void 0;
const _ = require("lodash");
class FolioController {
    constructor($scope, $q, folioService, $location, userService) {
        this.$scope = $scope;
        this.$q = $q;
        this.folioService = folioService;
        this.$location = $location;
        this.userService = userService;
        var isUploading = false;
        $scope.isUploading = () => isUploading;
        $scope.onFileSelect = ($files) => {
            $scope.files = $files;
        };
        $scope.$watch('files', (files) => {
            // Valideer de geselecteerde files die nog niet valide zijn
            var filesNotValidated = _.filter(files, file => !file.isValid);
            _.forEach(filesNotValidated, file => {
                file.description = 'Wordt geladen...';
                delete file.ics;
                folioService.parseICFromDocumentName(file.name).then((data) => {
                    if (data.errorCode || data.errorMessage) {
                        file.description = data.errorMessage || data.errorCode;
                        file.isValid = false;
                    }
                    else {
                        file.ics = [];
                        _.forEach(data.ics, ic => {
                            file.ics.push(ic);
                        });
                        file.isValid = true;
                    }
                });
            });
        });
        $scope.canUpload = () => {
            var files = $scope.files;
            if (!files || files.length === 0) {
                return false;
            }
            var allComplete = _.every(files, ['percentageComplete', 100]), allValid = _.every(files, ['isValid', true]), anyHasError = _.some(files, 'error');
            if (allComplete && !anyHasError) {
                return false;
            }
            if (!allValid) {
                return false;
            }
            return true;
        };
        $scope.upload = () => {
            var promises = [];
            isUploading = true;
            _.each($scope.files, (file) => {
                promises.push(folioService.upload(file));
            });
            $q.all(promises).finally(() => { isUploading = false; });
        };
        $scope.getICDescription = (ic) => {
            if (!ic || !ic.metadata) {
                return '';
            }
            return ic.metadata.weergaveTitel + ' (' + ic.metadata.vindplaats + ')';
        };
    }
}
exports.FolioController = FolioController;
FolioController.$inject = [
    '$scope',
    '$q',
    'folioService',
    '$location',
    'userService'
];
